import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [], // Array to store GSTR1 report data (categories with counts, taxes, etc.)
  loading: false,
  error: null,
};

const gstr2ReportSlice = createSlice({
  name: "Gstr2Report",
  initialState,
  reducers: {
    Gstr2ReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    Gstr2ReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; // Payload contains the processed GSTR1 report data
    },
    Gstr2ReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  Gstr2ReportRequest,
  Gstr2ReportSuccess,
  Gstr2ReportFailure,
} = gstr2ReportSlice.actions;

export default gstr2ReportSlice.reducer;

